import * as CL from '@design-system/component-library';
import { useDispatch } from 'react-redux';
import { dsClass } from '../../common/constants/dsClasses.js';
import { t } from '../../common/i18n/index.js';
import { initializePayment } from '../../selfservice/actions/index.js';
import { DialogWrapper } from '../DialogWrapper/index.js';
import type { CommonError } from '../../common/types/errors.js';

import './BankButtonsDialog.scss';

export interface BankButtonsDialogProps {
  balance: number;
  errors?: CommonError[];
  invoiceId: string;
  onCloseDialog: () => void;
}

export const BankButtonsDialog = ({ onCloseDialog, invoiceId, balance }: BankButtonsDialogProps) => {
  const dispatch = useDispatch();
  return (
    <DialogWrapper closeable header={t.WAIL('Select bank')} onCloseDialog={onCloseDialog} size="l">
      <CL.BankSelectGroup
        banks={[['op', 'nordea', 'danskebank', 'alandsbanken', 's-pankki', 'aktia', 'saastopankki', 'omasp']]}
        className={`${dsClass.PADDING_0} of-bank-buttons-dialog__buttons`}
        onBankSelect={bank => {
          const bankId = bank.htmlId;
          const PAYMENT_METHODS: Record<string, string> = {
            aktia: 'AKTIA',
            alandsbanken: 'ALANDSBANKEN',
            danskebank: 'DANSKE_BANK',
            nordea: 'NORDEA',
            omasp: 'OMA_SP',
            op: 'OSUUSPANKKI',
            /* eslint-disable @typescript-eslint/naming-convention */
            's-pankki': 'S_PANKKI',
            /* eslint-enable @typescript-eslint/naming-convention */
            saastopankki: 'SAASTOPANKKI',
          };

          if (bankId in PAYMENT_METHODS) {
            dispatch(initializePayment(invoiceId, balance, PAYMENT_METHODS[bankId]));
          }
        }}
      />
    </DialogWrapper>
  );
};
